module.exports = __webpack_public_path__ + "static/media/home_coin.9c4944eb.png";